import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import ApiRequest from "../../helper/ApiRequest";
import { usePermissions } from "../../helper/PermissionContext";

// Each top-level menu group = one permission slug from the API.
const MENU = {
  dashboard: "dashboard",
  userManagement: "user-management",
  blogManagement: "blog-management",
  seoManagement: "seo-management",
  galleryManagement: "gallery-management",
  globalSeo: "global-seo",
  sitemapManagement: "sitemap-management",
  llmsManagement: "llms-management",
  robotsManagement: "robots-management",
  emailManagement: "email-management",
  contactPageQuery: "contact-page-query",
  broucherPageQuery: "broucher-page-query",
  contactWellnessQuery: "contact-wellness-query",
  faqManagement: "faq-management",
};

export default function SideBar({ isOpen, toggleSidebar }) {
  const [isBlogManagementOpen, setIsBlogManagementOpen] = useState(false);
  const [isGalleryManagementOpen, setIsGalleryManagementOpen] = useState(false);
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);

  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const toggleBlogManagement = () => setIsBlogManagementOpen((prev) => !prev);
  const toggleGalleryManagement = () => setIsGalleryManagementOpen((prev) => !prev);
  const toggleUserManagement = () => setIsUserManagementOpen((prev) => !prev);

  const handleLogout = async () => {
    try {
      await ApiRequest("POST", "api/logout");
    } finally {
      sessionStorage.removeItem("AccessTokenTms");
      navigate("/login");
    }
  };

  return (
    <>
      <div className={`admin-logo-wrap ${isOpen ? "close" : "open"}`}>
        <img src="/assets/logo.webp" alt="logo" className="img-responsive" />
        <button className="toggle-button" onClick={toggleSidebar}>☰</button>
      </div>

      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <div className="scroller-sidebar">
          <ul style={isOpen
            ? { transition: "all 0.3s ease-in", opacity: "0", visibility: "hidden" }
            : { transition: "all 0.3s ease-in", opacity: "1", visibility: "visible" }}>

            {hasPermission(MENU.dashboard) && (
              <li>
                <Link to="/"><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" />Dashboard</span></Link>
              </li>
            )}

            {hasPermission(MENU.userManagement) && (
              <li className={`innertab ${isUserManagementOpen ? "openlist" : ""}`} onClick={toggleUserManagement}>
                <div><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" /> User Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isUserManagementOpen ? "open" : "close"}`}>
                  <li><Link to="users">Users</Link></li>
                  <li><Link to="roles">Roles</Link></li>
                  <li><Link to="permissions">Permissions</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.blogManagement) && (
              <li className={`innertab ${isBlogManagementOpen ? "openlist" : ""}`} onClick={toggleBlogManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Blog Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isBlogManagementOpen ? "open" : "close"}`}>
                  <li><Link to="blog">Blog</Link></li>
                  <li><Link to="category">Category</Link></li>
                  <li><Link to="author">Author</Link></li>
                  <li><Link to="tag">Tag</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.seoManagement) && (
              <li>
                <Link to="/seo"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />SEO Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.galleryManagement) && (
              <li className={`innertab ${isGalleryManagementOpen ? "openlist" : ""}`} onClick={toggleGalleryManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Gallery Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isGalleryManagementOpen ? "open" : "close"}`}>
                  <li><Link to="gallery-categories">Gallery Categories</Link></li>
                  <li><Link to="gallery">Gallery</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.globalSeo) && (
              <li>
                <Link to="/global-seo"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />Global SEO</span></Link>
              </li>
            )}

            {hasPermission(MENU.sitemapManagement) && (
              <li>
                <Link to="/sitemap"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />Sitemap Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.llmsManagement) && (
              <li>
                <Link to="/llms"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />LLMS Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.robotsManagement) && (
              <li>
                <Link to="/robots"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />Robots.txt Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.emailManagement) && (
              <li>
                <Link to="/email-management"><span><img src="/assets/newsletter.webp" alt="icon" className="img-responsive" />Email Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.contactPageQuery) && (
              <li>
                <Link to="/contact-page-query"><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" />Contact Page Query</span></Link>
              </li>
            )}

               {hasPermission(MENU.broucherPageQuery) && (
              <li>
                <Link to="/broucher-page-query"><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive"/>Broucher Query</span></Link>
              </li>
            )}


            {hasPermission(MENU.contactWellnessQuery) && (
              <li>
                <Link to="/corporate-query"><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" />Corporate Wellness Query</span></Link>
              </li>
            )}

            {hasPermission(MENU.faqManagement) && (
              <li>
                <Link to="/faq"><span><img src="/assets/news-icon.webp" alt="icon" className="img-responsive" />FAQ Management</span></Link>
              </li>
            )}

          </ul>
        </div>

        <button onClick={handleLogout} className="default-btn logout-button">Logout<span></span></button>
      </div>
    </>
  );
}
